import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export function BankAccount({ accountName, clientRef, sortCode, accountNumber }) {
    const formatSortCode = sortCode =>
        sortCode
            ? `${sortCode.substring(0, 2)}-${sortCode.substring(2, 4)}-${sortCode.substring(4, 6)}`
            : "";

    return (
        <BADiv data-testid="bank-account-details">
            <BAp>
                <span>{accountName || clientRef.toString()}</span>
                <br />
                <span>{formatSortCode(sortCode)}</span>
                <br />
                <span>{accountNumber}</span>
            </BAp>
        </BADiv>
    );
}

export const BADiv = styled.div`
    float: left;
    margin-right: 20px;
`;

export const BAp = styled.p`
    font-size: 1em;
    text-align: left;
    width: inherit;
    display: inline-block;
`;

BankAccount.propTypes = {
    clientRef: PropTypes.number,
    sortCode: PropTypes.string,
    accountName: PropTypes.string,
    accountNumber: PropTypes.string
};
